import { CheckCircleTwoTone } from '@ant-design/icons'
import { CubeIcon } from '@heroicons/react/outline'
import { useTranslation } from 'react-i18next'
import ProductSearch from './ProductSearch'

const ProductListHeader = ({
  pendingItemsToBeReviewed,
  productSearch,
  productSearchRef,
  onSearchChange = value => {},
  productSearchDependencies,
  productSearchAlertMsg,
  useNewDesign = false,
  activePackageLabel = null,
  searchDisabled = false,
  acceptsUnitCode = false,
}) => {
  const { i18n } = useTranslation()

  const title = useNewDesign ? i18n.t('generate_shipment.multi_box.product_table.title') : i18n.t('generate_shipment.product_list.required_products')
  const subtitlePending = useNewDesign ? i18n.t('generate_shipment.multi_box.product_table.subtitle') : i18n.t('generate_shipment.product_list.scan_all_items')

  return (
    <div className="flex justify-between">
      <div>
        <div className="flex p-1 gap-2">
          <h2 className="mb-0 text-2xl font-bold">{title}</h2>

          {pendingItemsToBeReviewed === 0 && (
            <div className="flex flex-col justify-center">
              <CheckCircleTwoTone style={{ fontSize: '20px' }} twoToneColor="#52c41a" />
            </div>
          )}
        </div>

        {pendingItemsToBeReviewed > 0 && <span className="mb-0 text-lg">{subtitlePending}</span>}
        {pendingItemsToBeReviewed === 0 && (
          <span className="mb-0 text-lg text-green-400 font-medium">{i18n.t('generate_shipment.product_list.order_complete')}</span>
        )}
      </div>

      {/* ONE stable wrapper around the scan input, whether or not the
                packing-context label ("Estás empacando en Paquete N") is showing.
                Branching between two different element trees here made React
                unmount and recreate the <input> every time the label toggled —
                i.e. on every box open/close of the multi-box flow — and the
                keyboard focus died with the old node. The barcode scanner is a
                keyboard: it types into whatever has the focus, so the next scan
                went nowhere and the operator refreshed the page. The label is
                optional INSIDE the wrapper; the input node never changes identity.
                Wrapper takes ~40% of the parent row (`w-2/5`) — with a sane floor
                for narrow viewports while the label is up, vertically centred
                (legacy look) while it isn't. The inner `<div className="w-full">`
                + `fullWidth` make the input span the wrapper instead of
                collapsing to the pill width. */}
      <div className={`flex flex-col items-end gap-2 w-2/5 ${activePackageLabel ? 'min-w-[260px]' : 'justify-center'}`}>
        {activePackageLabel && (
          <div className="flex items-center gap-2 text-sm text-blue-700">
            <span>{i18n.t('generate_shipment.multi_box.packing_context_label')}</span>
            <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-md bg-blue-50 border border-blue-200 font-semibold">
              <CubeIcon className="w-4 h-4" />
              {activePackageLabel}
            </span>
          </div>
        )}
        <div className="w-full">
          <ProductSearch
            search={productSearch}
            inputRef={productSearchRef}
            onSearchChange={onSearchChange}
            dependencies={productSearchDependencies}
            alertMsg={productSearchAlertMsg}
            disabled={searchDisabled}
            acceptsUnitCode={acceptsUnitCode}
            fullWidth
          />
        </div>
      </div>
    </div>
  )
}

export default ProductListHeader
